import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PuebloBase } from '@components/pueblo-base.component';
import { Pueblo } from 'pueblo-types';

@Component({
  selector: 'leave-pueblo-dialog',
  templateUrl: 'leave-pueblo-dialog.component.html',
  imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeavePuebloDialog extends PuebloBase {
  private readonly dialogRef = inject(MatDialogRef);

  readonly $pueblo = input.required<Pueblo>({ alias: 'pueblo' });

  readonly leaveComplete = output();

  protected readonly $pending = signal(false);

  protected readonly JoinPolicy = Pueblo.Config.JoinPolicy;

  pbEffects(): void {
    effect(() => {
      const appUser = this.$appUser();
      if (!appUser) return;
      if (!appUser.joinedPueblos.includes(this.$pueblo().resourceName)) {
        this.leaveComplete.emit();
        this.$pending.set(false);
        this.dialogRef.close();
      }
    });
  }

  handleLeave() {
    this.$pending.set(true);
    this.httpStore.leavePueblo(this.$pueblo(), {
      onFailure: () => {
        this.$pending.set(false);
      },
    });
  }
}
